import React from "react";
import { useForm, Controller } from "react-hook-form";
import { Button } from "@shared/ui/button";
import { Label } from "@shared/ui/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/ui/select";

interface RejectionFilters {
  status?: string;
}

interface RejectionListFiltersProps {
  currentFilters: RejectionFilters;
  onApplyFilters: (filters: Partial<RejectionFilters>) => void;
  onResetFilters: () => void;
}

const statusOptions = [
  { value: "REJECTED", label: "Rejected" },
  { value: "REWORK_ASSIGNED", label: "Rework Assigned" },
];

export const RejectionListFilters: React.FC<RejectionListFiltersProps> = ({
  currentFilters,
  onApplyFilters,
  onResetFilters,
}) => {
  const form = useForm({
    defaultValues: {
      status: currentFilters.status || "ALL_STATUS",
    },
  });

  const handleApplyFilters = (data: any) => {
    const filtersToApply: Partial<RejectionFilters> = {};

    if (data.status && data.status !== "ALL_STATUS") {
      filtersToApply.status = data.status;
    }

    onApplyFilters(filtersToApply);
  };

  const handleResetFilters = () => {
    form.reset({
      status: "ALL_STATUS",
    });
    onResetFilters();
  };

  return (
    <form onSubmit={form.handleSubmit(handleApplyFilters)}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Status Dropdown */}
        <div className="space-y-2">
          <Label>Status</Label>
          <Controller
            name="status"
            control={form.control}
            render={({ field }) => (
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger>
                  <SelectValue placeholder="Select status" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="ALL_STATUS">All Status</SelectItem>
                    {statusOptions.map((status) => (
                      <SelectItem key={status.value} value={status.value}>
                        {status.label}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            )}
          />
        </div>

        {/* Actions */}
        <div className="col-span-1 md:col-span-2 lg:col-span-4 flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={handleResetFilters}>
            Reset Filters
          </Button>
          <Button type="submit">Apply Filters</Button>
        </div>
      </div>
    </form>
  );
};